import { OpenIcecat } from 'open-icecat'
import { ICProduct } from '@/models/icecat'
import Dimension, { Dimensions } from '@/utils/math/dimension'
import Weight from '@/utils/math/weight'

import _ from 'lodash'


class Icecat {
  public request: OpenIcecat
  constructor () {
    this.request = new OpenIcecat({ username: 'Thomas_vD', lang: 'en' })
  }

  get product () {
    return {
      keys: () => [ 'dimensions', 'weight', 'title', 'ean', 'categories', 'description', 'variants', 'brand', 'producer', 'meta', 'props' ],
      byEan: async (ean: string): Promise<ICProduct> => {
        const result = await this.request.getProduct({ GTIN: String(ean) }) as unknown as Promise<ICProduct>
        return result
      },
      extract: {
        all: (product: ICProduct) => {
          const ex = this.product.extract
          const { dimensions, weight, volume } = ex.dimensions(product) || {}
          const { title, ean, categories, description, variants } = ex.general(product) || {}
          const { brand, producer, meta } = ex.origin(product) || {}
          const props = ex.props(product) || {}
          // const images = ex.images(product) || {}

          return { dimensions, weight, title, ean, categories, description, variants, brand, producer, meta, props }
        },
        general: (product: ICProduct) => {
          const title = product.GeneralInfo.Brand
          const ean = product.GeneralInfo.GTIN
          const categories = [product.GeneralInfo.Category?.Name.Value]
          const description = product.GeneralInfo.Description?.LongDesc
          const variants = product.Variants?.map(v => v.ID)
          return { title, ean, categories, description, variants }
        },
        origin: (product: ICProduct) => {
          const brand = product.GeneralInfo.Brand
          const producer = undefined
          const part_number = product.GeneralInfo.BrandPartCode

          const meta = { part_number }
          return { brand, producer, meta }
        },
        props: (product: ICProduct) => {
          const props = {}
          const exclude = ['width', 'height', 'depth', 'weight', 'volume']
          product.FeaturesGroups?.forEach(fg => {
            fg.Features?.forEach(f => {
              const nameValue = _.kebabCase(f.Feature?.Name.Value)
              if (exclude.some(e => nameValue.includes(e))) return
              props[nameValue] = f.PresentationValue
            })
          })

          return props
        },
        // images: (product: ICProduct) => {
        //   return []
        // },
        dimensions: (product: ICProduct) => {
          let x,y,z,volume,weight: Weight = new Weight(0)

          product.FeaturesGroups?.forEach(fg => {
            fg.Features?.forEach(f => {
              const nameValue = _.kebabCase(f.Feature?.Name.Value)
              if (nameValue.includes('width')) x = new Dimension(f.PresentationValue)
              if (nameValue.includes('height')) y = new Dimension(f.PresentationValue)
              if (nameValue.includes('depth') || nameValue.includes('length')) z = new Dimension(f.PresentationValue)
              if (nameValue.includes('weight')) weight = new Weight(f.PresentationValue)
              if (nameValue.includes('volume')) volume = parseInt(f.PresentationValue) || null
            })
          })

          if (!x || !y || !z) return null

          return { dimensions: new Dimensions(x,y,z).to().value, weight: weight.value, volume }
        }
      }
    }
  }
}

export default new Icecat()
